import { useCallback, useEffect, useState } from "react";
import { Container, Row } from "reactstrap";
import { Apps, Contacts } from "../../../constants";
import { useAppDispatch } from "../../../reduxToolkit/hooks";
import { fetchContacts } from "../../../reduxToolkit/reducers/contactSlice";
import DetailsPanel from "./detailsPanel";
import Breadcrumbs from "../../../coreComponents/breadcrumbs";
import Sidebar from "./sidebar";

// This component manages the contacts page, including fetching data and handling tab navigation.
const ContactsContainer = () => {
  const dispatch = useAppDispatch();
  const [activeTab, setActiveTab] = useState(1);
  const changeTab = useCallback((tab: number) => setActiveTab(tab), []);

  useEffect(() => {
    dispatch(fetchContacts());
  }, [dispatch]);

  return (
    <>
      <Breadcrumbs mainTitle={Contacts} parent={Apps} />
      <Container fluid>
        <div className="message-wrap bookmark-wrap">
          <Row>
            <Sidebar activeTab={activeTab} setActiveTab={setActiveTab} changeTab={changeTab} />
            <DetailsPanel activeTab={activeTab} />
          </Row>
        </div>
      </Container>
    </>
  );
};

export default ContactsContainer;
